import { colors } from "../../../../../theme/tokens/variables";
import WorkflowIcon from "./icons/WorkflowIcon";

const StartWorkflowTask = ({ nodeData }: any) => {
  const mode = "dark";
  const darkMode = mode === "dark";

  const { task } = nodeData;
  const {
    inputParameters: { startWorkflow },
  } = task;

  return (
    <div style={{ paddingTop: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <div style={{ marginRight: "10px", flexShrink: 0 }}>
          <WorkflowIcon />
        </div>
        <div
          style={{
            fontSize: "0.8em",
            padding: "4px 8px",
            color: darkMode ? colors.gray14 : colors.gray01,
            background: darkMode ? colors.gray06 : colors.gray12,
            borderRadius: "5px",
            height: "fit-content",
          }}
        >
          Workflow
        </div>
        <div
          style={{
            padding: "0 8px",
            lineHeight: "2em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
          }}
        >
          <a
            href={`${window.location.origin}/workflowDef/${startWorkflow?.name}`}
            style={{ textDecoration: "none", color: "cyan" }}
            target="_blank"
            rel="noreferrer"
          >
            {startWorkflow?.name}
          </a>
        </div>
      </div>
    </div>
  );
};

export default StartWorkflowTask;
